<template>
  <div class="d-flex align-center gap-2 flex-wrap">
    <strong class="white-space--nowrap">{{ $t(LocalizationEnum.sale_conditions) }}: </strong>
    <CommonChip v-for="saleCondition in saleConditions" :key="saleCondition">
      {{ SaleConditionLabel[saleCondition] }}
    </CommonChip>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { SaleConditionsEnum, SaleConditionsLabelsObj } from '@/bundles/Comparables/enums/SaleConditionsEnum';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

interface ISaleConditionsLabel {
  SaleConditionLabel: typeof SaleConditionsLabelsObj;
}

export default Vue.extend({
  name: 'SaleConditionsLabel',

  components: { CommonChip },

  props: {
    saleConditions: {
      type: Array as PropType<SaleConditionsEnum[]>,
      required: true,
    },
  },

  data: (): ISaleConditionsLabel => ({
    SaleConditionLabel: SaleConditionsLabelsObj,
  }),
})
</script>
